<div class="todo-list-container"
     cdkDropList
     [cdkDropListData]="ref()?.url"
     (cdkDropListDropped)="drop($any($event))">
  @for (line of lines(); let i = $index; track line) {
    <app-todo-item cdkDrag
                   [cdkDragData]="line"
                   [cdkDragStartDelay]="pressToUnlock() ? 251 : 0"
                   [pressToUnlock]="pressToUnlock()"
                   [line]="line"
                   [origin]="origin()"
                   [plugins]="tags() || ref()?.tags || []"
                   (update)="update({ index: i, text: $event.text, checked: $event.checked })" />
  }
  @for (line of pushText(); let i = $index; track line) {
    <app-todo-item [line]="line"
                   [origin]="origin()"
                   [plugins]="tags() || ref()?.tags || []" />
  }
</div>
<div class="spacer"></div>
<input type="text"
       enterkeyhint="send"
       i18n-placeholder
       placeholder="Add..."
       [value]="addText()"
       (input)="addText.set($any($event.target).value)"
       [style.display]="addText() ? 'block' : 'none'"
       (keydown)="$event.key === 'Enter' && add($event) || true"
       (blur)="add()">
@for (e of serverErrors(); track e) {
  <div class="error">{{ e }}</div>
}
